export default __webpack_public_path__ + "static/media/icone certificado.49d887de.svg";